import Flux from '../../../../flux/Flux';
import style from './Tile.module.less';
import ReloadHelper from '../../../../utils/ReloadHelper.js';
import Translations from '../../../../utils/Translations.js';
import { generateKey } from '../../../../utils/CommonUtils.js';
import TileBadgeLive from '../../../TileGrid/Badge/TileBadgeLive.js';
import TileBadgeVideocall from '../../../TileGrid/Badge/TileBadgeVideocall.js';
import Languages from '../Base/Badges/Languages.js';

const onClickProfile = (e, linkVX) => {
	e.preventDefault();
	e.stopPropagation();
	ReloadHelper.reload(linkVX);
};

/**
 * @param {object} model
 * @param {'xs' | 'sm' | 'md' | 'lg' | 'xl'} [size='xs']
 * @param {boolean} showOfflineBorder
 * @param {boolean} showModelAge
 */
const modelAvatar = (model, size = Flux.Constants.Grid2.ModelAvatar.Size.SM, showOfflineBorder = false, showModelAge = false) => (
	<a href={model?.linkVX || model?.profileLink} className={style.tileModel} onClick={(e) => onClickProfile(e, model?.linkVX || model?.profileLink)}>
		{(model?.name || model?.actorName) && (
			<img
				src={model?.avatar?.url || model?.avatarPicture}
				className={[
					style.tileModelImage,
					style[`-${size}`],
					model?.online ? style.tileModelImageOnline : '',
					model?.onlineVideocall ? style.tileModelImageVideocall : '',
					showOfflineBorder && !model?.online && !model?.onlineVideocall ? style.tileModelImageOffline : '',
				].join(' ')}
			/>
		)}
		{(model?.name || model?.actorName) && (
			<div className={style.tileModelName}>
				{model?.name || model?.actorName} {showModelAge && model?.age ? '(' + model.age + ')' : null}
			</div>
		)}
	</a>
);

/**
 * @param {array} languages
 */
const actorLanguages = (languages, name) => (
	<div className={style.actorPlateLangWrapper}>
		<Languages spokenLanguages={languages} name={name} />
	</div>
);

const getBadges = (badgeData) => {
	const badges = [];

	if (badgeData?.newVideoCount > 0) {
		const text =
			badgeData.newVideoCount +
			' ' +
			(badgeData.newVideoCount === 1 ? Translations.get('ActorProfileNewVideo') : Translations.get('VideoGridNewestTitle'));
		badges.push(
			<span key={generateKey('new-video', badgeData.length)} className={'badge -newVideoCount'}>
				{text}
			</span>,
		);
	}

	if (badgeData?.online) {
		badges.push(<TileBadgeLive key={generateKey('tile-live', badges.length)} className="badge--normal" show={badgeData.online} />);
	}

	if (badgeData?.onlineVideocall) {
		badges.push(
			<TileBadgeVideocall
				key={generateKey('tile-videocall', badges.length)}
				className={'badge--normal' + (!badgeData?.isDildocontrolAvailable ? ' -float-right' : '')}
				show={badgeData.onlineVideocall}
			/>,
		);
	}

	return badges;
};

export { actorLanguages, modelAvatar,  getBadges };
